export default {
  Property: 'property',
};
